const mucjHeadCells = [
    {
   id: 'sau',
   label: 'SAU',
   padding: "0 0 0 6px",
   width: 75
   },
{
   id: 'exchange',
   label: 'Exchange',
   padding: "0 0 0 8px",
   width: 80

},
{
   id: 'cable_id',
   label: 'Cable ID',
   padding: "0 0 0 8px",
   width: 75
   },
{
   id: 'cable_weight',
   label: 'Weight(Tonnes)',
   padding: "0 0 0 8px",
   width: 95
   },
{
   id: 'cable_length',
   label: 'Length(m)',
   padding: "0 13px",
   width: 75
   },
{
   id: 'cable_gauge',
   label: 'Cable Gauge',
   padding: "0 0 0 16px",
   width: 70
   },
{
   id: 'solution',
   label: 'Solution',
   padding: "0 6px",
   width: 60

},
{
   id: 'cr_ref',
   label: 'CR Ref',
   padding: "0 10px",
   width: 75
   },
{
   id: 'created_at',
   label: 'Created at',
   padding: "0 0 0 12px",
   width: 75
   },
{
   id: 'creator_name',
   label: 'Creator name',
   padding: "0 0 0 12px",
   width: 70
   },
{
   id: 'ein',
   label: 'Creator EIN',
   padding: "0 0 0 10px",
   width: 70
   },
   {
      id:'view',
      label:'View',
      padding:"0 0 0 8px",
      width: 40
   }
];
export default mucjHeadCells;